<script>
  import Web3Modal from "web3modal";
  import { ethers } from "ethers";
  import NoWallet from "./NoWallet.svelte";
  import Footer from "./Footer.svelte";
  import Policy from "./Policy.svelte";
  import InputBox from "./InputBox.svelte";
  // import DateBox from "./DateBox.svelte";
  import Loading from "./Loading.svelte";
  import Modal from "./Modal.svelte";
  import { fade, fly } from "svelte/transition";
  import { ValidateEmail, ValidateWeb } from "./utils";
  // import { CoinbaseWalletSDK } from "@coinbase/wallet-sdk";
  import { DateInput } from "date-picker-svelte";
  let date;
  // let date = new Date();
  let name = "";
  let email = "";
  let job = "";
  let website = "";
  let social = "";
  let invite = "";
  let wallet = "";
  let error = "";
  let loading = false;
  let emailError = false;
  let webError = false;
  let socialError = false;
  let success = false;
  let policyToggle = false;
  let currentTab = "access";
  // let currentTab = "endorsement";
  // let date = "";
  let description = "";
  //toggle for modal text switch
  let toggle = false;

  const reset = () => {
    name = "";
    email = "";
    job = "";
    website = "";
    social = "";
    invite = "";
    wallet = "";
    error = "";
    date = null;
    description = "";
  };

  $: {
    if (currentTab) {
      reset();
    }
  }
  const url =
    "https://script.google.com/macros/s/AKfycbxRLqIqdDmb7us7qz4jorRfBT2PZ-8fwbKgSgqA-F0SeNQkD1BOQ1ZbEa4SZX-uF1rH/exec";

  async function doPost() {
    if (!(wallet && email && job && website && social && name)) {
      console.log("fill out");
      return;
    }

    if (!ValidateEmail(email)) {
      emailError = true;
      error = "An error occurred. Please try again";
    }
    if (!ValidateWeb(social)) {
      error = "An error occurred. Please try again";
      socialError = true;
    }
    if (!ValidateWeb(website)) {
      webError = true;
      error = "An error occurred. Please try again";
    }

    if (!(emailError || socialError || webError)) {
      try {
        success = false;
        error = false;
        loading = true;
        const res = await fetch(url, {
          method: "POST",
          body: JSON.stringify({
            name: name,
            email: email,
            "job title": job,
            website: website,
            "social network link": social,
            inviter: invite,
            wallet: wallet,
          }),
        });
        const json = await res.json();
        let result = JSON.stringify(json);
        console.log(result);
        name = "";
        email = "";
        job = "";
        website = "";
        social = "";
        invite = "";
        wallet = "";
        toggle = false;
        success =
          "A Request to join the Th3Syndicate has been sent! If approved you will receive an e-mail from us!";
        loading = false;
      } catch (error) {
        console.log(error);
      }
    }
    if (!success) {
      error = "An error occurred. Please try again";
    }
    loading = false;
    return;
  }

  async function sendEndorsement() {
    if (!(name && email && date && description && wallet)) {
      console.log("fill out");
      return;
    }

    if (!ValidateEmail(email)) {
      emailError = true;
      error = "An error occurred. Please try again";
      return;
    }

    try {
      success = false;
      error = false;
      loading = true;
      const res = await fetch(
        "https://script.google.com/macros/s/AKfycbybI3AnEINvmTTL0e7bDGTrxVOhRK7NroddULh3JGpyTv-6j3wZX1bNqrL6JVX97Rg/exec",
        {
          method: "POST",
          body: JSON.stringify({
            name: name,
            email: email,
            "date of event": date,
            description: description,
            wallet: wallet,
          }),
        }
      );
      const json = await res.json();
      let result = JSON.stringify(json);
      console.log(result);
      name = "";
      email = "";
      wallet = "";
      toggle = true;
      success =
        "A Request to join the Th3Syndicate has been sent! If approved you will receive an e-mail from us!";
      loading = false;
    } catch (error) {
      console.log(error);
    }

    if (!success) {
      error = "An error occurred. Please try again";
    }
    loading = false;
    return;
  }

  const closeModal = () => {
    success = false;
  };
  const closePolicy = () => {
    policyToggle = false;
  };
  let NoWalletToggle = false;
  const closeWallet = () => {
    NoWalletToggle = false;
  };

  const providerOptions = {};
  let web3Modal;
  let web3ModalInstance;
  let web3ModalProvider;
  async function connectWallet() {
    try {
      web3Modal = new Web3Modal({
        cacheProvider: true,
        providerOptions,
      });
      web3ModalInstance = await web3Modal.connect();
      web3ModalProvider = new ethers.providers.Web3Provider(web3ModalInstance);
      // console.log(web3ModalProvider);
      wallet = web3ModalProvider?.provider?.selectedAddress;
    } catch (error) {
      displayError(error);
    }
  }

  const displayError = (error) => {
    web3ModalInstance = {};
    NoWalletToggle = true;
  };
  // policyToggle = 1;
</script>

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
  <link
    href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;700&display=swap"
    rel="stylesheet"
  />
</svelte:head>
{#if policyToggle}
  <Policy {closePolicy} />
{/if}
{#if success}
  <Modal {closeModal} {toggle} />
{/if}

{#if loading}
  <Loading />
{/if}

{#if NoWalletToggle}
  <NoWallet {closeWallet} />
{/if}

<!-- <DateInput bind:value={d} /> -->

<!-- <DateInput /> -->
<main
  style={success || policyToggle || NoWalletToggle ? "overflow:hidden" : ""}
>
  <img
    class="logo"
    src="images/logoNoLoop.gif"
    alt=""
    in:fade={{ duration: 1000 }}
  />
  <div style="display: flex; flex-direction:column;">
    <span class="logo-text" in:fade={{ delay: 500, duration: 1000 }}
      >Secret Society of Leaders in</span
    >

    <span class="logo-text" in:fade={{ delay: 500, duration: 1000 }}>
      the Entertainment industry</span
    >
  </div>

  <div class="menu-wrapper" in:fly={{ y: 100, delay: 500, duration: 1000 }}>
    <div class="menu">
      <span
        style={currentTab == "access" ? "border-bottom: 5px white solid" : ""}
        on:click={() => (currentTab = "access")}>Apply&nbsp;for access</span
      >
      <span
        style={currentTab == "endorsement"
          ? "border-bottom: 5px white solid"
          : ""}
        on:click={() => (currentTab = "endorsement")}
        >Submit&nbsp;for endorsement</span
      >
    </div>
    <div class="hr" in:fade={{ delay: 1500, duration: 1000 }} />
  </div>
  <div class="body">
    {#if currentTab == "access"}
      <span
        class="invite"
        style="margin-top: 72px"
        in:fly={{ y: 100, delay: 500, duration: 1000 }}>By Invitation Only</span
      >
      <div
        class="apply-wrapper"
        in:fly={{ y: 100, delay: 500, duration: 1000 }}
      >
        <span class="sub-title">APPLY FOR ACCESS</span>
        <InputBox placeholder="Name" margin="42" bind:text={name} />
        <InputBox
          placeholder="Email"
          margin="50"
          bind:text={email}
          bind:error={emailError}
        />
        <InputBox
          placeholder="Job Title"
          margin="90"
          bind:text={job}
          side="Job"
        />

        <span class="sub-title">WEB AND SOCIAL MEDIA</span>
        <InputBox
          placeholder="Website Link"
          margin="119"
          side="Web"
          bind:text={website}
          bind:error={webError}
        />
        <InputBox
          placeholder="Social Network Link"
          margin="187"
          side="SNL"
          bind:text={social}
          bind:error={socialError}
        />

        <span class="sub-title">INVITED BY</span>
        <InputBox placeholder="Who invited you?" bind:text={invite} />

        <span class="sub-title">BLOCKCHAIN WALLET</span>
        {#if wallet}
          <div
            style="overflow: hidden; margin-bottom:10px; position: relative; width:100%"
          >
            <div
              style="margin-bottom:10px; font-size:13px; width:1000px; overflow: hidden; color:white"
            >
              {wallet}
            </div>
            <img
              class="clear"
              style="bottom: 5px;"
              src="images/close.png"
              alt=""
              on:click={() => (wallet = "")}
            />
          </div>
        {:else}
          <div
            class="btn"
            style="margin:14px 0 24px 0;"
            on:click={connectWallet}
          >
            <span>CONNECT WALLET</span>
          </div>
        {/if}

        <div class="hr" />
        <div class="trouble-container">
          <div class="trouble-text-wrapper">
            <img
              src="images/trouble.png"
              alt=""
              style="width:19px; margin-right: 7px;"
            />
            <span style="font-size:13px;">
              HAVING TROUBLE CONNECTING WALLET?</span
            >
          </div>
          <a
            style="font-size:16px; margin-top: 6px;
"
            class="discord-link"
            href="https://discord.gg/BEVYBK5ar3"
            target="_blank">Connect with us on DISCORD</a
          >
          <span style="font-size:12px"
            >message @redeyelou on our Discord for support</span
          >
        </div>
        <div
          class="btn"
          style="margin:24px 0 24px 0; {!(
            wallet &&
            email &&
            job &&
            website &&
            social
          )
            ? 'background:#666666; cursor: default;'
            : ''}"
          on:click={doPost}
        >
          <span>SEND REQUEST</span>
        </div>
        {#if error}
          <div class="error">
            <img src="images/error.png" alt="" />
            <span>{error}</span>
          </div>
          <!-- {:else if success}
        <div class="error">
          <img src="images/success.png" alt="" />
          <span>{success}</span>
        </div> -->
        {:else}
          <span style="font-size:14px; color: #ccc;">* Mandatory fields</span>
        {/if}
      </div>
    {:else if currentTab == "endorsement"}
      <div in:fade={{ duration: 1000 }}>
        <div class="endorsement-body" in:fly={{ y: 100, duration: 1000 }}>
          <span style="font-size:15px; font-weight: 700; margin-bottom: 11px;"
            >ABOUT SYNDICAT ENDORSEMENTS:</span
          >
          <span style="margin-bottom: 16px; font-size:14px; line-height: 24px;"
            >If you wish for Th3Syndicate community to support your event Fill
            out the form below. If approved the community will provide the
            following support:</span
          >
          <span style="font-size:14px; line-height: 24px;"
            ><strong>1)</strong> Allow you to add Th3Syndicate Crest to your promotional
            materials, website.
          </span>
          <span style="font-size:14px; line-height: 24px; margin-bottom: 16px;"
            >This inspires our members to selflessly support, activate and
            collaborate.</span
          >
          <span style="font-size:14px; line-height: 24px; margin-bottom: 16px;"
            ><strong>2)</strong> We will message community and make them aware of
            your project</span
          >
          <span style="font-size:14px; line-height: 24px; margin-bottom: 16px;"
            ><strong>3)</strong> We will work with you to add value, community and
            support to elevate the project</span
          >
          <span style="font-size:14px; line-height: 24px;"
            ><strong>4)</strong> We will activate Syndicate members to attend, support
            or promote</span
          >
          <span style="font-size:14px;  margin-top: 40px; line-height: 24px;"
            >→ We do not take engagements lightly and thus all endorsements
            require a
            <strong> unanimous vote of approval </strong>
            by High Leadership and our Board Members so not all will be confirmed.
          </span>
          <div class="hr" style="margin-top:20px;" />

          <div class="endorsement-bottom">
            <div style="display:flex; flex-direction:column;">
              <span
                style="font-size: 12px; line-height: 17px; letter-spacing: 0.1em;"
              >
                <strong>PLEASE NOTE:</strong>
                You must be Ranking member to request</span
              >
              <span
                style="font-size: 13px; line-height: 17px; letter-spacing: 0.1em;"
                on:click={() => (currentTab = "access")}
                >Not a Member? <a>
                  <strong style="text-decoration: underline; cursor:pointer;"
                    >APPLY NOW</strong
                  >
                </a>
              </span>
            </div>
            <div style="height:55px" />
            <span class="sub-title" style="margin-bottom: 10px;"
              >YOUR INFORMATION</span
            >
            <div style="height:35px" />
            <InputBox placeholder="Name" margin="42" bind:text={name} />
            <InputBox
              placeholder="Email"
              margin="50"
              bind:text={email}
              bind:error={emailError}
            />

            <div style="display:flex; flex-direction: column;">
              <span
                style="font-size:13px; font-weight:700; letter-spacing: 0.1em; margin-bottom: 15px;"
                >YOUR BLOCKCHAIN WALLET</span
              >
            </div>
            {#if wallet}
              <div
                style="overflow: hidden; margin-bottom:10px; position: relative; width:100%"
              >
                <div
                  style="margin-bottom:10px; font-size:13px; width:1000px; overflow: hidden; color:white"
                >
                  {wallet}
                </div>
                <img
                  class="clear"
                  style="bottom: 5px;"
                  src="images/close.png"
                  alt=""
                  on:click={() => (wallet = "")}
                />
              </div>
            {:else}
              <div
                class="btn"
                style="margin:14px 0 40px 0;"
                on:click={connectWallet}
              >
                <span>CONNECT WALLET</span>
              </div>
            {/if}
            <span style="font-size: 13px; font-weight: 700;"
              >YOUR EVENT YOU WISH FOR TH3SYNDICATE TO SUPPORT</span
            >
            <div style="height: 20px;" />
            <!-- <InputBox
              placeholder="Date of Event"
              margin="128"
              bind:text={date}
            /> -->
            <div class="date-input">
              <DateInput
                placeholder="Date of Event"
                closeOnSelection={true}
                format="MM/dd/yyyy"
                bind:value={date}
              />
            </div>
            <InputBox
              placeholder="Please describe the Event"
              margin="253"
              textarea={true}
              bind:text={description}
            />
            <div class="hr" style="margin-top: 30px" />
            <div
              class="btn"
              style="margin:40px 0 20px 0; {!(
                name &&
                email &&
                date &&
                description &&
                wallet &&
                !emailError
              )
                ? 'background:#666666; cursor: default;'
                : ''}"
              on:click={sendEndorsement}
            >
              <span>SUBMIT FOR ENDORSEMENT</span>
            </div>
            <span style="font-size:14px; color: #ccc;">* Mandatory fields</span>
          </div>
        </div>
      </div>
    {/if}
    <span class="btm-text"
      >together&nbsp;we&nbsp;are&nbsp;stronger&nbsp;/
      leave&nbsp;more&nbsp;than&nbsp;you&nbsp;take&nbsp;/
      gratefully&nbsp;conquer</span
    >
  </div>

  <Footer bind:policyToggle />
</main>

<style>
  * {
    box-sizing: border-box;
  }
  a {
    color: white;
    /* text-decoration: none; */
  }
  .sub-title {
    font-weight: 700;
    font-size: 13px;
    margin-top: 3px;
    margin-bottom: 39px;
  }
  main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    align-items: center;
  }
  .body {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 32px;
  }

  .endorsement-body {
    max-width: 430px;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 73px;
  }
  .endorsement-bottom {
    width: 100%;
    max-width: 426px;
    padding-top: 46px;
  }
  .logo {
    width: 224px;
    height: 234px;
    margin: 59px 0 31px 0;
  }

  .logo-text {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    box-sizing: border-box;
  }
  .menu-wrapper {
    margin-top: 100px;
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
  .menu {
    width: 100%;
    max-width: 450px;
    height: 40px;
    display: flex;
    justify-content: space-around;
  }
  .menu > span {
    /* position: absolute; */
    bottom: 0;
    cursor: pointer;
    padding: 0 10px;
  }
  .menu > span:hover {
    border-bottom: 5px white solid;
  }

  .invite {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
  }
  .apply-wrapper {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 426px;
    justify-content: left;
    position: relative;
  }
  .btn {
    width: 100%;
    height: 50px;
    display: grid;
    place-items: center;
    background: #cccccc;
    cursor: pointer;
  }
  .btn:hover {
    background: #ffffff;
  }
  .btn > span {
    color: black;
    font-weight: 600;
    font-size: 16px;
  }
  .hr {
    width: 100%;
    height: 1px;
    border-top: 1px solid #666;
  }
  .btm-text {
    width: 100%;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 44px;
    margin-bottom: 45px;
    margin-top: 70px;
  }
  .clear {
    background: black;
    width: 26px;
    right: -2px;
    padding: 5px;
    position: absolute;
    cursor: pointer;
    bottom: 214px;
  }

  .clear:hover {
    filter: brightness(2);
  }

  .error {
    display: flex;

    align-items: center;
  }
  .error > img {
    width: 24px;
  }
  .error > span {
    font-size: 13px;
    font-weight: 400;
    color: white;
    margin-left: 6px;
  }

  .trouble-container {
    display: flex;
    flex-direction: column;
    padding-top: 23px;
  }
  .trouble-text-wrapper {
    display: flex;
    align-items: center;
  }
  .discord-link {
    font-size: 13px;
  }

  @media only screen and (max-width: 600px) {
    .menu {
      height: 56px;
      width: 100%;
      max-width: none;
    }
    .menu > span {
      width: 50%;
      text-align: center;
    }
    .menu span:nth-child(1) {
      padding: 0 55px;
    }
    .menu span:nth-child(2) {
      padding: 0 70px;
    }
  }
  :global(body) {
    --date-picker-foreground: #f7f7f7;
    --date-picker-background: #16171c;
    --date-picker-highlight-border: hsl(var(--deg), 98%, 49%);
    --date-picker-highlight-shadow: hsla(var(--deg), 98%, 49%, 50%);
    --date-picker-selected-color: hsl(var(--deg), 100%, 85%);
    --date-picker-selected-background: hsla(var(--deg), 98%, 49%, 20%);
    /* background: #0d0e12; */
    /* color: #ffffff; */
    /* transition: all 0.5s ease-in-out; */
    /* font-size: 14px; */
  }
  .date-input {
    width: 100%;
    margin-bottom: 20px;
  }
  :global(.date-time-field > input) {
    background: orange;
  }
</style>
